!function() {
  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, n = {}, t = {}, o = e.parcelRequire5f74;
  null == o && ((o = function(e) {
    if (e in n) return n[e].exports;
    if (e in t) {
      var o = t[e];
      delete t[e];
      var i = {
        id: e,
        exports: {}
      };
      return n[e] = i, o.call(i.exports, i, i.exports), i.exports;
    }
    var r = new Error("Cannot find module '" + e + "'");
    throw r.code = "MODULE_NOT_FOUND", r;
  }).register = function(e, n) {
    t[e] = n;
  }, e.parcelRequire5f74 = o), (0, o.register)("jqqn3", function(e, n) {
    var t, o, i, r;
    function s(e, n = 5e3) {
      return new Promise((t, o) => {
        const i = Date.now(), r = setInterval(() => {
          window[e] ? (clearInterval(r), t(window[e])) : Date.now() - i >= n && (clearInterval(r), 
          o(new Error(`'${e}' did not become available within ${n}ms.`)));
        }, 100);
      });
    }
    t = e.exports, o = "waitForGlobal", i = function() {
      return s;
    }, Object.defineProperty(t, o, {
      get: i,
      set: r,
      enumerable: !0,
      configurable: !0
    });
  });
  var i = o("jqqn3");
  (() => {
    if (!customElements.get("cookie-renew")) {
      class e extends HTMLElement {
        constructor() {
          super(), this.buttonEl = this.querySelector("button"), this.handleClick = this.handleClick.bind(this), 
          this.handleChange = this.handleChange.bind(this);
        }
        handleClick() {
          window.Cookiebot.renew();
        }
        handleChange(e) {
          window.Cookiebot.hasResponse ? this.style.display = "block" : this.style.display = "none";
        }
        _handleUrlParameters() {
          const e = new URLSearchParams(window.location.search);
          if (!e.has("mbfcb")) return !1;
          const n = "true" === e.get("mbfcb");
          e.delete("mbfcb");
          const t = e.toString(), o = `${window.location.pathname}${t ? "?" + t : ""}`;
          return window.history.replaceState({}, document.title, o), n;
        }
        async connectedCallback() {
          if (this._handleUrlParameters()) return console.warn("[CookieBanner] Preview mode active. Banner will not be shown."), 
          void (this.hidden = !0);
          if (!this.buttonEl) return console.error("Cookie-renew is missing a button"), void (this.style.display = "none");
          try {
            await (0, i.waitForGlobal)("Cookiebot", 5e3), window.Cookiebot.hasResponse && (this.style.display = "block"), 
            this.buttonEl.addEventListener("click", this.handleClick), window.addEventListener("CookiebotOnAccept", this.handleChange), 
            window.addEventListener("CookiebotOnDecline", this.handleChange);
          } catch (e) {
            console.error(e.message), this.style.display = "none";
          }
        }
        disconnectedCallback() {
          this.buttonEl && (this.buttonEl.removeEventListener("click", this.handleClick), 
          window.removeEventListener("CookiebotOnAccept", this.handleChange), window.removeEventListener("CookiebotOnDecline", this.handleChange));
        }
      }
      customElements.define("cookie-renew", e);
    }
  })();
}();